import { Box, Chip, Divider, Stack, Typography, useTheme } from "@mui/material";
import Logo from "../../Components/Logo/logo-svg";
import { useTranslation } from "react-i18next";

type ScribetoolFooterProps = {
  fps: number;
  subCount: number;
  duration: string;
};

export const ScribetoolFooter: React.FC<ScribetoolFooterProps> = ({ duration, subCount, fps }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <footer
      style={{
        height: "36px",
        position: "absolute",
        bottom: "0px",
        left: "0px",
        right: "0px",
        zIndex: 1100,
        backgroundColor: theme.palette.background[200],
        overflow: "hidden",
      }}
    >
      <Stack alignItems={"center"} display={"flex"} justifyContent={"space-between"} flexDirection={"row"}>
        <Stack
          sx={{ color: theme.palette.grey[400], pb: 0.5, pt: 0.7 }}
          height="100%"
          direction="row"
          display="flex"
          alignItems="center"
          alignContent="center"
        >
          <Typography sx={{ ml: 1.5 }} variant="body1">
            {t("page:body.totalTime")}
          </Typography>
          <Chip label={`${duration}`} sx={{ ml: 1.5, mr: 1.5 }} />
          <Divider sx={{ display: "list-item" }} orientation="vertical" />
          <Typography sx={{ ml: 1.5 }} variant="body1">
            {t("page:body.videoFps")}
          </Typography>
          <Chip label={`${fps} fps`} sx={{ ml: 1.5, mr: 1.5 }} />
          <Divider sx={{ display: "list-item" }} orientation="vertical" />
          <Typography sx={{ ml: 1.5 }} variant="body1">
            {t("page:body.clipCount")}
          </Typography>
          <Chip label={t("chip:label.subtitlesRows", { count: subCount })} sx={{ ml: 1, mr: 1 }} />
        </Stack>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Logo color={theme.palette.text.primary} sx={{ mr: 1.5 }} />
        </Box>
      </Stack>
    </footer>
  );
};
